import { render, staticRenderFns } from "./RevisionObservation.vue?vue&type=template&id=721eec28&scoped=true"
import script from "./RevisionObservation.vue?vue&type=script&lang=js"
export * from "./RevisionObservation.vue?vue&type=script&lang=js"
import style0 from "./RevisionObservation.vue?vue&type=style&index=0&id=721eec28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721eec28",
  null
  
)

export default component.exports